// API Endpoints
const endpoints = {
  // Auth endpoints
  auth: {
    register: '/auth/register',
    login: '/auth/login',
    profile: '/auth/profile',
    forgotPassword: '/auth/forgot-password',    // ADD
  verifyResetOtp: '/auth/verify-reset-otp',   // ADD
  resetPassword: '/auth/reset-password',       // ADD
  },

  // User endpoints
  users: {
    list: '/users',
    approve: (userId) => `/users/${userId}/approve`,
    reject: (userId) => `/users/${userId}/reject`
  },

  // Permission endpoints
  permissions: {
    grant: '/permissions/grant',
    revoke: (permissionId) => `/permissions/${permissionId}`,
    update: (permissionId) => `/permissions/${permissionId}`,
    myPermissions: '/permissions/me',
    granted: '/permissions/granted',
    userPermissions: (userId) => `/permissions/user/${userId}`
  },

  // Host endpoints
  hosts: {
    list: '/hosts',
    all: '/hosts/admin/all',
    create: '/hosts',
    getById: (hostId) => `/hosts/${hostId}`,
    update: (hostId) => `/hosts/${hostId}`,
    delete: (hostId) => `/hosts/${hostId}`,
    toggleStatus: (hostId) => `/hosts/${hostId}/toggle-status`,
    transfer: (hostId) => `/hosts/${hostId}/transfer`
  },

  // Contest endpoints
  contests: {
    list: '/contests',
    all: '/contests/admin/all',
    create: '/contests',
    getById: (contestId) => `/contests/${contestId}`,
    update: (contestId) => `/contests/${contestId}`,
    delete: (contestId) => `/contests/${contestId}`,
    togglePause: (contestId) => `/contests/${contestId}/toggle-pause`,
    toggleResults: (contestId) => `/contests/${contestId}/toggle-results`,
    stats: (contestId) => `/contests/${contestId}/stats`,
    public: '/contests/public',
    publicDetail: (contestId) => `/contests/${contestId}/public`
  },

  // Category endpoints
  categories: {
    list: '/categories',
    create: '/categories',
    getById: (categoryId) => `/categories/${categoryId}`,
    update: (categoryId) => `/categories/${categoryId}`,
    delete: (categoryId) => `/categories/${categoryId}`,
    byContest: (contestId) => `/categories/contest/${contestId}`
  },

  // Contestant endpoints
  contestants: {
    list: '/contestants',
    create: '/contestants',
    getById: (contestantId) => `/contestants/${contestantId}`,
    update: (contestantId) => `/contestants/${contestantId}`,
    delete: (contestantId) => `/contestants/${contestantId}`,
    byCategory: (categoryId) => `/contestants/category/${categoryId}`
  },

  // Vote endpoints
  votes: {
    cast: '/votes/cast',
    manual: '/votes/manual',
    byContest: (contestId) => `/votes/contest/${contestId}`,
    stats: (contestId) => `/votes/contest/${contestId}/stats`,
    daily: (contestId) => `/votes/contest/${contestId}/daily`,
    delete: (id) => `/votes/${id}`,
    bulkDelete: `/votes/bulk-delete`,
    recalculate: (contestId) => `/votes/contest/${contestId}/recalculate`
  },

  // Payment endpoints
  payments: {
    initialize: '/payments/paystack/initialize',
    verify: (reference) => `/payments/paystack/verify/${reference}`,
    byContest: (contestId) => `/payments/contest/${contestId}`,
    stats: (contestId) => `/payments/contest/${contestId}/stats`
  },

  // ✅ Analytics endpoints (NEW)
  analytics: {
    global: '/analytics/global', // Super Admin only
    contestAnalytics: (contestId) => `/analytics/contests/${contestId}/analytics`,
    dailyAnalytics: (contestId) => `/analytics/contests/${contestId}/analytics/daily`,
    paymentAnalytics: (contestId) => `/analytics/contests/${contestId}/analytics/payments`,
    voterHistory: (contestId) => `/analytics/contests/${contestId}/voters`,
    voterStatistics: (contestId) => `/analytics/contests/${contestId}/voters/statistics`
  }
};

export default endpoints;